import { render, staticRenderFns } from "./onDrop.vue?vue&type=template&id=97123acc"
import script from "./onDrop.vue?vue&type=script&lang=js"
export * from "./onDrop.vue?vue&type=script&lang=js"
import style0 from "./onDrop.vue?vue&type=style&index=0&id=97123acc&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports